export default __webpack_public_path__ + "static/media/655.bf2476de.jpg";